var map = {
	"./service_1.jpg": 6211,
	"./service_2.jpg": 4300,
	"./service_3.jpg": 1200,
	"./service_4.jpg": 8341,
	"./service_5.jpg": 1914,
	"./service_6.jpg": 9905,
	"./service_7.jpg": 7699,
	"./service_8.jpg": 2469
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4218;